export const roomAdKeys = {
  all: ['room-ads'],
  list: (params: any) => ['room-ads', 'list', params],
  detail: (id: any) => ['room-ads', 'detail', id],
};
